import React, { FC } from 'react';

import CustomIcon from '@components/utils/CustomIcon';
import { DownArrowIcon, User3 } from '@assets/icons';
import { getPeopleInformations } from '@utils/utils';
import SearchGuest from '@components/ui/search/SearchGuest/SearchGuest';
import useSearchBar from '@contexts/searchbar';
import { HotelSearchBarActionType } from '@contexts/searchbar/types/hotel';

import { InputWrapper, StyledInput } from './HotelSearchGuestStyle';
import { IHotelSearchGuest } from './HotelSearchGuest';

const DesktopSearchGuest: FC<IHotelSearchGuest> = ({
  totalGuestCount,
  onChange,
  value,
}) => {
  const {
    state: { hotel: state },
    dispatch,
  } = useSearchBar();

  const rooms = value || state.rooms;

  return (
    <SearchGuest
      popoverStyles={{
        marginTop: '-4px',
        width: '360px',
      }}
      isSingleLineDatePicker
      rooms={rooms}
      setHotelRooms={(rooms) =>
        onChange
          ? onChange(rooms)
          : dispatch({
              type: HotelSearchBarActionType.SET_ROOMS,
              payload: rooms,
            })
      }
      renderParentComponent={() => (
        <InputWrapper>
          <StyledInput
            className='select-guest-component'
            placeholder='Yolcu Seçimi'
            value={getPeopleInformations(
              totalGuestCount.adultCount,
              totalGuestCount.childCount,
              0,
              rooms.length
            )}
            readOnly
            prefix={
              <CustomIcon fontSize={24} paletteColor='grey500' icon={User3} />
            }
            suffix={
              <CustomIcon
                fontSize={18}
                paletteColor='grey800'
                icon={DownArrowIcon}
              />
            }
          />
        </InputWrapper>
      )}
    />
  );
};

export default DesktopSearchGuest;
